module.exports = __webpack_public_path__ + "media/images/icon_main_articles-4b95e165bdb32d35ce3abc65f486c1cf.svg";